import { render } from "./StartGameDemo.vue?vue&type=template&id=3184a952"
import script from "./StartGameDemo.vue?vue&type=script&lang=js"
export * from "./StartGameDemo.vue?vue&type=script&lang=js"

import "./StartGameDemo.vue?vue&type=style&index=0&id=3184a952&lang=css"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__